<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form label-width="150px" :model="dataForm">
        <el-form-item label="收入金额：">
          {{ dataForm.Amount }}
        </el-form-item>
        <el-form-item label="资金来源：">
          {{ SourceType(dataForm.Source) }}
        </el-form-item>
        <el-form-item label="公益项目名称：" v-if="dataForm.Source == 0">
          {{ dataForm.ProjectName }}
        </el-form-item>
        <el-form-item label="款项说明：">
          {{ dataForm.Explain }}
        </el-form-item>
        <el-form-item label="到账时间：">
          {{ (dataForm.FinishTime * 1000) | formatDate }}
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";
import { saveAs } from 'file-saver';


export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      width: "60%",
      fileList: [], //附件数组
    };
  },
  components: {
    OfDialog,
  },
  mounted(){
      let that=this;
      that.getfile();
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    SourceType(item) {
      switch (item) {
        case 0:
          return "社会捐赠";
        case 1:
          return "财政拨款";
        case 2:
          return "其他";
      }
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
.of-dialog >>> .el-button--primary {
  display: none;
}
.of-dialog >>> .el-button--default {
  display: none;
}
.upload-demo >>> .el-icon-close {
  display: none !important;
}
.upload-demo >>> .el-icon-close-tip {
  display: none !important;
}
.upload-demo>>>.el-upload-dragger{
    display: none !important;
}
</style>
